<template>
  <AnalyticsWidget
    title="Purchasing Summary"
    subTitle="Based on active purchase orders"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    >
    <div class="p-2">
      <LoadingPanel :loading="loading" />
      <div v-if="!loading">
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue
              title="Bulk Purchase Orders"
              :value="bulkPOCount">
              {{bulkPOCount}}
              <template v-slot:info>Active purchase orders containing {{bulkBlockCount}} blocks with {{bulkBlockSheetCount}} sheets</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Standard Purchase Orders"
              :value="standardPOCount">
              {{standardPOCount}}
              <template v-slot:info>Active purchase orders containing {{standardSheetCount}} stock sheets</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="External Purchase Orders"
              :value="externalPOCount">
              {{externalPOCount}}
              <template v-slot:info>Active external purchase orders linked to orders</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>
      </div>
    </div>
  </AnalyticsWidget>
</template>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'
import AnalyticsDashboardValueRow from '@/modules/intelligence/components/analyticsDashboardValueRow'

import { InventoryStockTypes, PurchaseOrderStatusTypes, PurchaseOrderTypes } from '@/store/types'

export default {
  name: 'PurchasingSummaryWidget',
  components: {
    AnalyticsWidget,
    AnalyticsDashboardValue,
    AnalyticsDashboardValueRow
  },
  props: {
    filter: Object,
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    bulkPOCount() {
      if(!this.purchasingSummary.orderSummaryList)
        return 0
      return this.purchasingSummary.orderSummaryList.reduce((curValue, item) => {
        if(item.status == PurchaseOrderStatusTypes.pendingApproval)
          return curValue
        if(item.type == PurchaseOrderTypes.bulk)
          return curValue + item.totalCount
        return curValue
      }, 0)
    },
    bulkBlockCount() {
      if(!this.purchasingSummary.itemSummaryList)
        return 0
      return this.purchasingSummary.itemSummaryList.reduce((curValue, item) => {
        if(item.purchaseOrderStatus == PurchaseOrderStatusTypes.pendingApproval)
          return curValue
        if(item.purchaseOrderType == PurchaseOrderTypes.bulk && item.isBlock && item.stockType == InventoryStockTypes.glass)
          return curValue + item.totalBlockQuantity
        return curValue
      }, 0)
    },
    bulkBlockSheetCount() {
      if(!this.purchasingSummary.itemSummaryList)
        return 0
      return this.purchasingSummary.itemSummaryList.reduce((curValue, item) => {
        if(item.purchaseOrderStatus == PurchaseOrderStatusTypes.pendingApproval)
          return curValue
        if(item.purchaseOrderType == PurchaseOrderTypes.bulk && item.isBlock && item.stockType == InventoryStockTypes.glass)
          return curValue + item.totalQuantity
        return curValue
      }, 0)
    },
    standardPOCount() {
      if(!this.purchasingSummary.orderSummaryList)
        return 0
      return this.purchasingSummary.orderSummaryList.reduce((curValue, item) => {
        if(item.status == PurchaseOrderStatusTypes.pendingApproval)
          return curValue
        if(item.type == PurchaseOrderTypes.standard)
          return curValue + item.totalCount
        return curValue
      }, 0)
    },
    standardSheetCount() {
      if(!this.purchasingSummary.itemSummaryList)
        return 0
      return this.purchasingSummary.itemSummaryList.reduce((curValue, item) => {
        if(item.purchaseOrderStatus == PurchaseOrderStatusTypes.pendingApproval)
          return curValue
        if(item.purchaseOrderType == PurchaseOrderTypes.standard && item.stockType == InventoryStockTypes.glass && !item.isProcessedItem)
          return curValue + item.totalQuantity
        return curValue
      }, 0)
    },
    externalPOCount() {
      if(!this.purchasingSummary.orderSummaryList)
        return 0
      return this.purchasingSummary.orderSummaryList.reduce((curValue, item) => {
        if(item.status == PurchaseOrderStatusTypes.pendingApproval)
          return curValue
        if(item.type == PurchaseOrderTypes.externalOrder)
          return curValue + item.totalCount
        return curValue
      }, 0)
    },
  },
  data() {
    return {
      loading: true,
      purchasingSummary: {}
    }
  },
  watch: {
    filter: function() {
      this.requestData()
    }
  },
  mounted() {
    this.loading = true
    this.requestData()    
  },
  methods: {
    requestData() {
      var params = {
        accountLocationId: this.filter ? this.filter.accountLocationIdList : null
      }

      this.$apiService.analyticsService.getPurchaseOrderSummary(params)
      .then(response => {
        this.purchasingSummary = response.data
      })
      .finally(() => {
        this.loading = false
      })
      
    },
    
  }
}
</script>